import React from "react";
import ReactDOM from "react-dom";
import AutoCloseConfig from "./components/AutoCloseConfig";
import {
  findCompanyConfigSettings,
  findCompanyDetail,
} from "../../infrastructure/repository/company-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { logError } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

export function renderAutoCloseConfig({
  company,
  selectableDays,
  configSettings,
}) {
  const target = document.getElementById("auto-close-config-container");

  if (target) {
    ReactDOM.render(
      <AutoCloseConfig
        company={company}
        selectableDays={selectableDays}
        configSettings={configSettings}
      />,
      target
    );
  }
}

export async function displayAutoCloseConfig() {
  try {
    const { data: company } = await findCompanyDetail();
    const { data: configSettings } = await findCompanyConfigSettings();
    const selectableDays = [];
    for (
      let i = configSettings.firstPossibleDayToClosePayroll;
      i <= 31;
      i += 1
    ) {
      selectableDays.push(i);
    }

    renderAutoCloseConfig({ company, selectableDays, configSettings });
  } catch (e) {
    logError(e, `Error to displayAutoCloseConfig`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
